var React = require('react');

function Pulse (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"m43 0h-38c-2.75228 0-5 2.24772-5 5v30c0 2.7523 2.24772 5 5 5h38c2.7523 0 5-2.2477 5-5v-30c0-2.75228-2.2477-5-5-5zm-38 2h38c1.6477 0 3 1.35228 3 3v30c0 1.6477-1.3523 3-3 3h-38c-1.64772 0-3-1.3523-3-3v-30c0-1.64772 1.35228-3 3-3zm17.3507 4.8118-5.9957 13.1882h-8.355v2h9.6439l4.0051-8.812 3.8837 18.4465 6.0203-9.6345h8.447v-2h-9.5542l-3.9788 6.366z","fill":"#04968b","fillRule":"evenodd"}));
}

Pulse.defaultProps = {"fill":"none","height":"40","viewBox":"0 0 48 40","width":"48"};

module.exports = Pulse;

Pulse.default = Pulse;
